var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMindset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 320,
    height: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.08 14.776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m342.56 404.76-.6-111.3-54 90.6h-26.4l-53.7-87.6v108.3h-54.9v-210h55l67.7 111.49 66.25-111.49h54.65l.6 210z",
    style: {
      fill: "gray"
    },
    transform: "translate(-149.854 -154.701)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.766,
    cy: 174.509,
    r: 18.97,
    style: {
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.766,
    cy: 231.419,
    r: 18.97,
    style: {
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.766,
    cy: 117.589,
    r: 18.97,
    style: {
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.766,
    cy: 60.669,
    r: 18.97,
    style: {
      fill: "#e79933"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindset);
export default __webpack_public_path__ + "static/media/mindset.e9580b6c6d778633319ba00ccacaa9b2.svg";
export { ForwardRef as ReactComponent };